

import deepCopy from "../../utilities/deepCopy";
import {
  CLEAN_FILTERS,
  DELETE_FILTER, LOAD_FILTERS_ERROR, LOAD_FILTERS_LIMBO, LOAD_FILTERS_REQUEST, LOAD_FILTERS_SUCCESS,
  TOGGLE_FILTER, TOGGLE_IS_SCORE
} from "./filters-action-types";
import {prepareFiltersToSend, toggleFilter, toggleIsScore} from "./functions";

const initialState = {
  loading: false,
  filters: [],
  filtersLimbo: [],
  filtersToSend: [],
  loaded: false,
  error: "",
  whoMounted: null
};


export default (state = initialState, action ) => {
  const { filters, error, filterIndex, containerIndex, all, index, reportUrl } = action;
  const filtersCopy = deepCopy(state.filters);

  switch(action.type) {

    case LOAD_FILTERS_LIMBO:
      return {
        ...state,
        filtersToSend: deepCopy(state.filtersLimbo)
      };

    case CLEAN_FILTERS:
      return {
        ...state,
        filtersToSend: [],
        filtersLimbo: deepCopy(state.filtersToSend)
      };

    case TOGGLE_IS_SCORE:

      toggleIsScore({filters: filtersCopy, filterIndex});

      return {
        ...state,
        filters: filtersCopy,
        filtersToSend: prepareFiltersToSend(filtersCopy)
      };


    case DELETE_FILTER:
      filtersCopy.splice(index, 1);
      return {
        ...state,
        filters: filtersCopy,
        filtersToSend: prepareFiltersToSend(filtersCopy)
      };

    case TOGGLE_FILTER:
      toggleFilter(filtersCopy, containerIndex, filterIndex, all);
      return {
        ...state,
        filters: filtersCopy,
        filtersToSend: prepareFiltersToSend(filtersCopy)
      };

    case LOAD_FILTERS_REQUEST:
      return {
        ...state,
        loading: true,
        whoMounted: reportUrl,
        error: ""
      };

    case LOAD_FILTERS_SUCCESS:
      return {
        ...state,
        filters,
        loading: false,
        loaded: true,
        error: ""
      };

    case LOAD_FILTERS_ERROR:
      return {
        ...state,
        loading: false,
        error
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/filters/filters-reducer.js